import { Component, forwardRef, Input, Output, Optional, TemplateRef, EventEmitter, ViewChild } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DwFormControlComponent } from 'ng-quicksilver';
import { AbstractDwFormItemComponent } from '../../../../../../projects/webdpt/framework/components/form-field/abstract-dw-form-item-component';
import { FxUserInfoService } from 'app/implementation/auth/fx-auth/fx-user-info.service';
import { TranslateParser } from '@ngx-translate/core';

@Component({
  selector: 'dw-number-format',
  template: `
    <dw-form-item-panel [dwFlex]="dwFlex"
                        [dwRequired]="dwRequired"
                        [dwFor]="dwFor"
                        [dwLabelOffset]="dwLabelOffset"
                        [dwLabelOrder]="dwLabelOrder"
                        [dwLabelPull]="dwLabelPull"
                        [dwLabelPush]="dwLabelPush"
                        [dwLabelSpan]="dwLabelSpan"
                        [dwLabelXs]="dwLabelXs"
                        [dwLabelSm]="dwLabelSm"
                        [dwLabelMd]="dwLabelMd"
                        [dwLabelLg]="dwLabelLg"
                        [dwLabelXl]="dwLabelXl"
                        [dwLabelXXl]="dwLabelXXl"
                        [dwHasFeedback]="dwHasFeedback"
                        [dwInputOffset]="dwInputOffset"
                        [dwInputOrder]="dwInputOrder"
                        [dwInputPull]="dwInputPull"
                        [dwInputPush]="dwInputPush"
                        [dwInputSpan]="dwInputSpan"
                        [dwInputXs]="dwInputXs"
                        [dwInputSm]="dwInputSm"
                        [dwInputMd]="dwInputMd"
                        [dwInputLg]="dwInputLg"
                        [dwInputXl]="dwInputXl"
                        [dwInputXXl]="dwInputXXl"
                        [validationMessages]="validationMessages"
                        [dwValidateStatus]="control"
                        [dwLabel]="dwLabel">
        <input dw-input
               [dwSize]="dwSize"
               (change)="change($event)"
               [(ngModel)]="dwValue"
              
               [disabled]="dwDisabled || isDisabled"
               (blur)="blur($event)"
               (click)="click($event)"
               [attr.placeholder]="dwPlaceHolder">
    </dw-form-item-panel>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FxNumberFormatComponent),
      multi: true
    }
  ]
})
export class FxNumberFormatComponent extends AbstractDwFormItemComponent {

  @Input() dwPlaceHolder: string;
  @Input() dwDisabled: boolean = false;
  @Input() dwAddOnAfter: string | TemplateRef<void>;
  @Input() dwAddOnAfterIcon: string | string[] | Set<string> | { [klass: string]: any; };
  @Input() dwAddOnBefore: string | TemplateRef<void>;
  @Input() dwAddOnBeforeIcon: string | string[] | Set<string> | { [klass: string]: any; };
  @Input() dwPrefix: string | TemplateRef<void>;
  @Input() dwPrefixIcon: string | string[] | Set<string> | { [klass: string]: any; };
  @Input() dwSuffix: string | TemplateRef<void>;
  @Input() dwSuffixIcon: string | string[] | Set<string> | { [klass: string]: any; };
  @Input() dwCompact: boolean = false;
  @Input() dwSearch: boolean = false;
  @Input() dwSize: string;
  @Input() dwType: string = 'default'; // 小数位数类别
  @Input() dwCode: string = 'default'; // 小数位代码
  @Input() dwMin: number;          // 最小值
  @Input() dwMax: number;          // 最大值
  @Input() dwPositiveNum: number;   // 正数的小数点位数
  @Input() dwNegtiveNum: number;   // 负数的小数点位数
  @Input() dwHasZero: boolean = false; // 是否允许输入00开头的数值
  // @Output() dwValueChange = new EventEmitter<any>();
  @Output() dwBlur = new EventEmitter<any>();
  @Output() dwClick = new EventEmitter<any>();
  defaultDecimal = null;
  decimal = null;
  defaultRoundType = null;
  roundType = null;
  oldDwValue = ''; // 记录旧值
  constructor(@Optional() protected _fg: ControlContainer,
    @Optional() protected _ts: TranslateParser,
    private fxUserService: FxUserInfoService) {
    super(_fg, _ts);
  }

  afterContentInit(): void { }

  change(event: any): void {
    this.ngModelChange(event, true);
    this.onChange(this.dwValue);
  }

  ngModelChange($event, isSetNewValue): void {
    if (this.dwHasZero) {
      this.dwValue = this.dwValue.replace(/\D/g, '');
      this.oldDwValue = this.dwValue;
    } else if (this.dwPositiveNum >= 0) {
      var reg1 = '^(\\d|([1-9]\\d+))(\\.\\d{0,' + this.dwPositiveNum + '})?$';
      // 等于0时，改判断大于等于0的整数
      if (this.dwPositiveNum === 0) {
        var reg1 = '^(\\d|([1-9]\\d+))?$';
      }
      if (new RegExp(reg1).test(this.dwValue) !== true && this.dwValue && isSetNewValue) {
        this.dwValue = this.oldDwValue;
      } else {
        if (((this.dwMin !== undefined && this.dwValue < this.dwMin) || (this.dwMin !== undefined && this.dwValue > this.dwMax)) && this.dwValue && isSetNewValue) {
          this.dwValue = this.oldDwValue;
        } else {
          this.oldDwValue = this.dwValue;
        }
      }
    } else if (this.dwNegtiveNum >= 0) {
      var reg2 = '^(-|-?(\\d|([1-9]\\d+)))(\\.\\d{0,' + this.dwNegtiveNum + '})?$';
      // 等于0时，改判断大于等于0的整数
      if (this.dwNegtiveNum === 0) {
        var reg2 = '^(-|-?(\\d|([1-9]\\d+)))?$';
      }
      if (new RegExp(reg2).test(this.dwValue) !== true && this.dwValue && isSetNewValue) {
        this.dwValue = this.oldDwValue;
      } else {
        if (((this.dwMin !== undefined && this.dwValue < this.dwMin) || (this.dwMin !== undefined && this.dwValue > this.dwMax)) && this.dwValue && isSetNewValue) {
          this.dwValue = this.oldDwValue;
        } else {
          this.oldDwValue = this.dwValue;
        }
      }
    } else {
      var reg3 = '^(\\d|([1-9]\\d+))(\\.\\d{0,' + this.decimal + '})?$';
      if (this.decimal == 0) {
        var reg3 = '^(\\d|([1-9]\\d+))?$';
      }
      if (new RegExp(reg3).test(this.dwValue) !== true && this.dwValue && isSetNewValue) {
        this.dwValue = this.oldDwValue;
      } else {
        if (((this.dwMin !== undefined && this.dwValue < this.dwMin) || (this.dwMin !== undefined && this.dwValue > this.dwMax)) && this.dwValue && isSetNewValue) {
          this.dwValue = this.oldDwValue;
        } else {
          this.oldDwValue = this.dwValue;
        }
      }
    }
    // this.dwValueChange.emit(this.dwValue);
  }

  blur($event): void {
    // this.ngModelChange($event, true)
    this.dwBlur.emit($event);
  }

  click($event): void {
    this.dwClick.emit($event);
  }
  get value(): any {
    return this.dwValue;
  }

  set value(value: any) {    
    if (value !== this.dwValue) {
      this.dwValue = value;     
    }
  }
  onInit(): void {

    var items = [];
    if (this.dwType === 'unit') {
      items = this.fxUserService.getUnitParam([]);
    } else if ((['amountDecimal', 'priceDecimal'])
      .indexOf(this.dwType) !== -1) {
      items = this.fxUserService.getCurrencyParam([]);
    }

    for (var i = 0; i < items.length; i++) {
      var val = items[i];
      if (val.bacunit) {
        if (val.bacunit === 'default') {
          this.defaultDecimal = val.bac002;
          this.defaultRoundType = val.bac003;
        }

        if (val.unit === this.dwCode) {
          this.decimal = val.bac002;
          this.roundType = val.bac003;
        }
      } else {
        if (val.baacurr === 'default') {
          switch (this.dwType) {
            case 'amountDecimal':
              this.defaultDecimal = val.baa001;
              this.defaultRoundType = val.baa003;
              break;

            case 'priceDecimal':
              this.defaultDecimal = val.baa002;
              this.defaultRoundType = val.baa003;
              break;

            default:
              break;
          }
        }
        if (val.baacurr === this.dwCode) {
          switch (this.dwType) {
            case 'amountDecimal':
              this.decimal = val.baa001;
              this.roundType = val.baa003;
              break;

            case 'priceDecimal':
              this.decimal = val.baa002;
              this.roundType = val.baa003;
              break;

            default:
              break;
          }
        }
      }
    }
    // items.forEach(function (val) {
    // if (val.bacunit) {
    //   if (val.bacunit === 'default') {
    //     this.defaultDecimal = val.bac002;
    //     this.defaultRoundType = val.bac003;
    //   }

    //   if (val.unit === this.dwCode) {
    //     this.decimal = val.bac002;
    //     this.roundType = val.bac003;
    //   }
    // } else {
    //   if (val.baacurr === 'default') {
    //     switch (this.dwType) {
    //       case 'amountDecimal':
    //         this.defaultDecimal = val.baa001;
    //         this.defaultRoundType = val.baa003;
    //         break;

    //       case 'priceDecimal':
    //         this.defaultDecimal = val.baa002;
    //         this.defaultRoundType = val.baa003;
    //         break;

    //       default:
    //         break;
    //     }
    //   }
    //   if (val.baacurr === this.dwCode) {
    //     switch (this.dwType) {
    //       case 'amountDecimal':
    //         this.decimal = val.baa001;
    //         this.roundType = val.baa003;
    //         break;

    //       case 'priceDecimal':
    //         this.decimal = val.baa002;
    //         this.roundType = val.baa003;
    //         break;

    //       default:
    //         break;
    //     }
    //   }
    // }
    // });
    if (this.decimal === null) this.decimal = this.defaultDecimal;
    if (this.roundType === null) this.roundType = this.defaultRoundType;
  }


}
